import { useParams } from "react-router-dom";
import { cuesApi } from "./imports";

import CueEditOffset from "./shared/CueEditOffset";

export default function CueEditOffsetWrapper({ cue }) {
	const { projectId } = useParams();

	const handleOnUpdate = (update) => {
		cuesApi.updateCue(cue.id, projectId, update);
	};

	return <CueEditOffset cue={cue} onUpdate={handleOnUpdate} />;
}
